export default "__VITE_ASSET__Cyn8LSxZ__"